module.exports = __webpack_public_path__ + "static/media/diamond.f281f29b.svg";